import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import CheckoutForm from './CheckoutForm';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_CAN);

class StripePaymentCA extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        console.log('Stripe CA')
        console.log('stripePromise', stripePromise)
        return (
            <Elements stripe={stripePromise}>
                <CheckoutForm
                    client={this.props.client}
                    cartPricing={this.props.cartPricing}
                    checkoutStripePayment={this.props.checkoutStripePayment}
                    stripeRequestPayment={this.props.stripeRequestPayment}
                    setIsPaymentEnabled={this.props.setIsPaymentEnabled}
                    hasQuestionNotAnswered={this.props.hasQuestionNotAnswered}
                />
            </Elements>
        );
    }
}

export default StripePaymentCA;


// WEBPACK FOOTER //
// ./src/components/Common/StripePayment/StripePaymentCA.js